import checkboxStyles from "../../../styles/UI/checkbox.module.css";
import { ReactComponent as CheckIcon } from "../../../assets/icons/check_white.svg";

const Checkbox = ({
  checked,
  onChange,
  label,
}: {
  checked: boolean;
  onChange: (isChecked: boolean) => void;
  label?: string;
}) => {
  return (
    <label className="flex cursor-pointer gap-[var(--spacing-sm)] items-center">
      <input
        className={checkboxStyles.nativeCheckbox}
        checked={checked}
        type="checkbox"
        onChange={(e) => onChange(e.target.checked)}
      />
      <span className={checkboxStyles.checkbox}>
        {checked && <CheckIcon />}
      </span>
      {label && <span className="text-sm">{label}</span>}
    </label>
  );
};

export default Checkbox;
